import { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNotify, FunctionField } from 'react-admin';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CircularProgress from '@mui/material/CircularProgress';
import { PROCESS_STATUS_SUCCESS_SEND } from '../../../constants/choices/processStatusChoice';
import { downloadCsvSendHistory } from '../utils';


const MENU_LABELS = {
    download: 'Download de Envio',
    downloading: 'Baixando...',
    downloadUnavailable: 'Download de Envio indisponível',
  };


  const SendHistoryActionsMenuContent = ({ record }) => {
    const notify = useNotify();
    const [anchorEl, setAnchorEl] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    }
    
    const handleClose = () => {
      setAnchorEl(null);
    }

    const handleDownload = async () => {
      handleClose();
      if (!record?.id) {
        notify('Histórico de envio não encontrado', {type: 'warning'});
        return;
      }
      setDownloading(true);
      notify('Download de envio em andamento...', {type: 'info'});
      try {
        await downloadCsvSendHistory(record.id, record.cycleId);
        notify('Download de envio concluído', {type: 'success'});
      } catch (error) {
        const errorMessage = error?.message || 'Erro ao baixar CSV de envio';
        notify(errorMessage, {type: 'error'});
      } finally {
        setDownloading(false);
      }
    }

    const isDownloadDisabled = record.processStatusId !== PROCESS_STATUS_SUCCESS_SEND || downloading;

    return (
      <>
      <IconButton
          aria-label="Mais ações"
          aria-controls={open ? 'send-history-actions-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleOpen}
          size="small"
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="send-history-actions-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ onClick: (e) => e.stopPropagation() }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleDownload} 
          disabled={isDownloadDisabled}
          >
          <ListItemIcon>
            {downloading ? <CircularProgress size={20} /> : <CloudDownloadIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText
            primary={downloading ? MENU_LABELS.downloading : MENU_LABELS.download}
            secondary={isDownloadDisabled ? MENU_LABELS.downloadUnavailable : null}
          />
        </MenuItem>
        </Menu>
      </>
    )
  }

  const SendHistoryActionsMenu = (props) => (
    <FunctionField
      label="Ações"
      render={(record) => <SendHistoryActionsMenuContent record={record} />}
      {...props}
    />
  );
  export default SendHistoryActionsMenu;

  